import { createSlice } from "@reduxjs/toolkit";
import { elliottAdvocacyAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const elliottAdvocacySlice = createSlice({
  name: "elliottAdvocacy",
  initialState: data,
  reducers: {
    elliottAdvocacySlice(state) {
      state.isLoading = false;
    },
    elliottAdvocacySliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    elliottAdvocacySliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    elliottAdvocacySliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const elliottAdvocacyHandler = () => async (dispatch: any) => {
  try {
    dispatch(elliottAdvocacyAction.elliottAdvocacySlice());
    const response: any = await elliottAdvocacyAPI();
    dispatch(elliottAdvocacyAction.elliottAdvocacySliceSuccess(response));
  } catch (e: any) {
    dispatch(elliottAdvocacyAction.elliottAdvocacySliceFailure(e?.response?.data?.message));
    dispatch(elliottAdvocacyAction.elliottAdvocacySliceReset());
  }
};
export default elliottAdvocacySlice.reducer;
export const elliottAdvocacyAction = elliottAdvocacySlice.actions;
